import React, { useState, FC } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ArrowDropDown } from '@mui/icons-material';
import { AxiosError } from 'axios';
import { useMutation } from 'react-query';
import { updateUserProfile } from '../../api/apiRequests/user';
import { IUserProfileFields } from '../../lib/interfaces/User';
import { LANGUAGES } from '../../lib/consts/languages';

type LanguageMenuProps = {
	hide?: boolean;
};

const LanguageMenu: FC<LanguageMenuProps> = ({ hide = false }) => {
	const { t, i18n } = useTranslation();
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const handleLanguageMenuOpen = (
		event: React.MouseEvent<HTMLButtonElement>,
	) => {
		setAnchorEl(event.currentTarget);
	};

	const handleLanguageMenuClose = () => {
		setAnchorEl(null);
	};

	const userMutation = useMutation<
		Partial<IUserProfileFields>,
		AxiosError<any>,
		Partial<IUserProfileFields>
	>((data) => updateUserProfile(data), {
		onSuccess: (datas) => {
			console.log('success', datas);
		},
	});

	const handleLanguageMenuClick = (language: LANGUAGES) => {
		i18n.changeLanguage(language).then(() => {
			// dispatch(updateUserLaguage(language));
			userMutation.mutate({ language });
		});
		setAnchorEl(null);
	};

	return hide ? null : (
		<>
			<Button
				aria-controls="languages"
				aria-haspopup="true"
				onClick={handleLanguageMenuOpen}
				color="primary"
			>
				{i18n.language === 'en' ? t('english') : t('russian')}
				<ArrowDropDown />
			</Button>

			<Menu
				id="languages"
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleLanguageMenuClose}
			>
				<MenuItem onClick={() => handleLanguageMenuClick(LANGUAGES.en)}>
					{t('english')}
				</MenuItem>
				<MenuItem onClick={() => handleLanguageMenuClick(LANGUAGES.ru)}>
					{t('russian')}
				</MenuItem>
			</Menu>
		</>
	);
};

export default LanguageMenu;
